module.exports = __webpack_public_path__ + "graphics/promo-upgrade.ckh.2e01643f561372f88e13b8a90c136687.svg";